import { Injectable } from '@angular/core';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';

@Injectable({
  providedIn: 'root'
})

export class RouteNavigateService {

  constructor(private appUtilityService: AppUtilityService) {

  }

  public getNavigationURL(): string {
    const deviceType =  this.appUtilityService.getMobileOperatingSystem().toLowerCase();
    switch (deviceType) {
      case 'android': {
        return 'http://maps.google.com/?saddr=Current%20Location&daddr=';
      }
      case 'ios': {
        return 'https://maps.apple.com/?daddr={LAT}%2C{LON}&dirflg=d';
      }
    }
  }
}
